// @ts-nocheck
import translate from "@insite/client-framework/Translate";
import useReportApi from "@store/Framework/Common/Hooks/useReportAPI/useReportAPI";
import { isManufacturersPickerModel } from "@store/Framework/Services/Reporting/ReportingTypeGuards";
import { reportParametersSelector } from "@store/Framework/Store/Bunzl/Pages/Reporting/ReportOrderFrequency/ReportOrderFrequencySelectors";
import { GetReportOrderFrequencyApiParameter } from "@store/Framework/Types/types";
import ModalPicker from "@store/Library/Components/Reporting/ModalPicker/ModalPicker";
import useCheckboxPicker from "@store/Library/Components/Reporting/ModalPicker/useCheckboxPicker";
import { get } from "js-cookie";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";

interface Manufacturers {
    [key: string]: string[];
}
interface Props {
    isError: boolean;
    setSelectedManufacturers: (selectedItems: string[]) => void;
}

const ManufacturerPicker: React.FC<Props> = ({ isError, setSelectedManufacturers }) => {
    const { selectedItems, setSelectedItems, toggleItem, toggleAllItems } = useCheckboxPicker();
    const { updateData, isLoading } = useReportApi("manufacturers");
    const [manufacturers, setManufacturers] = useState<string[]>([]);
    const reportApiParams = useSelector(reportParametersSelector);
    const [manufacturersData, setManufacturersData] = useState<Manufacturers>({});
    const getManufacturers = async () => {
        if (!reportApiParams.customers.length) {
            setManufacturers([]);
            setManufacturersData({});
            setSelectedItems([]);
            setSelectedManufacturers([]);
            return;
        }
        const manufacturersReturn = await updateData({
            customers: reportApiParams.customers,
            // startDate: reportApiParams.startDate,
            // endDate: reportApiParams.endDate,
        } as GetReportOrderFrequencyApiParameter);
        if (isManufacturersPickerModel(manufacturersReturn)) {
            // hot patching wesclean out of the data
            const manufacturersWithoutWesclean = manufacturersReturn.items.map(item => {
                const name = item.name.includes("WESCLEAN") ? "BUNZL REGARD" : item.name;
                return { ...item, name };
            });
            const uniqueManufacturers = [...new Set(manufacturersWithoutWesclean.map(item => item.name))];
            setManufacturers(uniqueManufacturers);
            const manufacturersData = manufacturersWithoutWesclean.reduce((acc: Manufacturers, item) => {
                if (!acc[item.name]) {
                    acc[item.name] = [];
                }
                acc[item.name].push(item.vendorID);
                return acc;
            }, {});
            setManufacturersData(manufacturersData);
            if (selectedItems.length) {
                const remainingSelectedItems = selectedItems.filter(item => uniqueManufacturers.includes(item));
                const remainingSelectedIds = ([] as string[]).concat(
                    ...remainingSelectedItems.map(item => manufacturersData[item]),
                );
                setSelectedItems(remainingSelectedItems);
                setSelectedManufacturers(remainingSelectedIds);
            }
        }
    };

    useEffect(() => {
        const selectedVendorIds = ([] as string[]).concat(...selectedItems.map(item => manufacturersData[item]));
        setSelectedManufacturers(selectedVendorIds);
    }, [selectedItems]);

    return (
        <ModalPicker
            emptyMessage={translate("No Manufacturers Found, Select a Customer to see Manufacturers")}
            onOpen={getManufacturers}
            data={manufacturers}
            toggleAllItems={toggleAllItems}
            header={translate("Manufacturers")}
            isLoading={isLoading}
            selectedItems={selectedItems}
            toggleItem={toggleItem}
        />
    );
};

export default ManufacturerPicker;
